<!--
 * @Descripttion: DeepPay UPI 在线支付页面
 * @Author: congz
 * @Date: 2020-06-11 11:08:34
 * @LastEditors: congz
 * @LastEditTime: 2020-08-18 23:15:35
-->
<template>
  <div class="payment" id="payment" name="payment">
    <div class="payment-content" v-if="order">
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="payment-header">
          <span>UPI Online Payment</span>
        </div>
        <div class="payment-body" v-if="!payUrl">
          <div class="payment-loading">
            <i class="el-icon-loading"></i>
            <p>Initializing payment...</p>
            <el-button type="primary" @click="initPayment" :loading="initLoading" size="small">Retry</el-button>
          </div>
        </div>
        <div class="payment-body" v-else>
          <!-- Order info -->
          <div class="order-summary">
            <p><strong>Order:</strong> {{ order.order_num }}</p>
            <p><strong>Amount:</strong> ₹{{ amount }}</p>
          </div>

          <!-- QR Code -->
          <div class="qr-section">
            <p class="qr-hint">Scan the QR code with any UPI app to pay</p>
            <img
              v-if="payUrl"
              :src="'https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=' + encodeURIComponent(payUrl)"
              alt="UPI QR Code"
              class="qr-img"
            />
            <p class="qr-status" v-if="polling">
              <i class="el-icon-loading"></i> Waiting for payment...
            </p>
          </div>

          <!-- Pay with app -->
          <div class="wallet-buttons">
            <p class="wallet-hint">Or pay directly with:</p>
            <div class="wallet-list">
              <a class="wallet-btn phonepe-btn" :href="phonePeUrl" target="_blank">
                <span class="wallet-icon">
                  <svg viewBox="0 0 24 24" width="24" height="24"><circle cx="12" cy="12" r="10" fill="#5F259F"/><text x="12" y="17" text-anchor="middle" fill="#fff" font-size="11" font-weight="700">P</text></svg>
                </span>
                PhonePe
              </a>
              <a class="wallet-btn gpay-btn" :href="googlePayUrl" target="_blank">
                <span class="wallet-icon">
                  <svg viewBox="0 0 24 24" width="24" height="24"><rect x="2" y="4" width="20" height="16" rx="2" fill="#fff" stroke="#dadce0" stroke-width="1"/><path d="M7.5 8l3.5 5-3.5 3" stroke="#4285F4" stroke-width="1.8" fill="none" stroke-linecap="round" stroke-linejoin="round"/><rect x="13" y="8" width="5" height="8" rx="1" fill="#EA4335"/></svg>
                </span>
                Google Pay
              </a>
            </div>
          </div>

          <!-- Actions -->
          <div class="payment-actions">
            <el-button @click="cancelPay" size="small">Cancel</el-button>
            <el-button type="primary" @click="checkStatus" size="small" :loading="checking">
              Check Payment Status
            </el-button>
          </div>
        </div>
      </el-card>
    </div>
    <div class="not-found" v-else>Loading order...</div>
  </div>
</template>

<script>
import * as ordersAPI from '@/api/orders'
import * as paymentAPI from '@/api/payment'

export default {
  name: 'Payment',
  data() {
    return {
      orderNum: '',
      order: null,
      payUrl: '',
      deepPayOrderNo: '',
      deepPayMchOrderNo: '',
      amount: '0',
      polling: false,
      pollTimer: null,
      initLoading: false,
      checking: false
    }
  },
  activated() {
    if (this.$route.query.orderNum) {
      this.orderNum = this.$route.query.orderNum
    }
  },
  watch: {
    orderNum: function() {
      this.loadOrder()
    }
  },
  computed: {
    phonePeUrl() {
      if (!this.payUrl) return '#'
      return this.payUrl.replace('upi://pay?', 'phonepe://pay?')
    },
    googlePayUrl() {
      if (!this.payUrl) return '#'
      return this.payUrl.replace('upi://pay?', 'gpay://upi/pay?')
    }
  },
  methods: {
    loadOrder() {
      ordersAPI.showOrder(this.orderNum).then(res => {
        if (res.status === 200 && res.data) {
          this.order = res.data
          this.amount = res.data.amount ||
            String((res.data.discount_price || res.data.price) * (res.data.num || 1))
          // Check if already paid
          if (res.data.type === 2) {
            this.notifySucceed('Order already paid')
            this.$router.push({ path: '/order/details', query: { orderNum: this.orderNum } })
            return
          }
          this.initPayment()
        } else if (res.status === 20001) {
          this.loginExpired(res.msg)
        } else {
          this.notifyError('Failed to load order', res.msg)
        }
      }).catch(err => {
        this.notifyError('Failed to load order', err)
      })
    },

    initPayment() {
      this.initLoading = true
      this.payUrl = ''
      paymentAPI.initOnlinePayment({
        order_num: String(this.orderNum),
        amount: String(this.amount),
        // 优先用收货人姓名（真实姓名）；账号昵称可能是 user_3318 这类内部号，DeepPay 会拒绝
        nickname:
          (this.order && this.order.address_name) ||
          (this.$store.getters.getUser && this.$store.getters.getUser.nickname) ||
          'Customer',
        phone: (this.order && this.order.address_phone) || '',
        email: (this.order && this.order.address_email) || ''
      }).then(res => {
        this.initLoading = false
        if (res.status === 200 && res.data && res.data.pay_url) {
          this.payUrl = res.data.pay_url
          this.deepPayOrderNo = res.data.order_no || ''
          this.deepPayMchOrderNo = res.data.mch_order_no || ''
          this.polling = true
          this.startPolling()
        } else {
          this.notifyError('Failed to initialize payment', res.msg)
        }
      }).catch(err => {
        this.initLoading = false
        this.notifyError('Payment initialization failed', err)
      })
    },

    startPolling() {
      this.stopPolling()
      this.pollTimer = setInterval(() => {
        ordersAPI.showOrder(this.orderNum).then(res => {
          if (res.data && res.data.type === 2) {
            this.stopPolling()
            this.polling = false
            this.notifySucceed('Payment successful!')
            this.$router.push({ path: '/order/details', query: { orderNum: this.orderNum } })
          }
        }).catch(() => {})
      }, 5000)
    },

    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer)
        this.pollTimer = null
      }
    },

    checkStatus() {
      this.checking = true
      ordersAPI.showOrder(this.orderNum).then(res => {
        this.checking = false
        if (res.data && res.data.type === 2) {
          this.stopPolling()
          this.polling = false
          this.notifySucceed('Payment confirmed!')
          this.$router.push({ path: '/order/details', query: { orderNum: this.orderNum } })
        } else {
          this.$message.info('Payment not yet received. Please complete the UPI payment.')
        }
      }).catch(() => {
        this.checking = false
      })
    },

    cancelPay() {
      this.stopPolling()
      this.$router.push({ path: '/order/details', query: { orderNum: this.orderNum } })
    }
  },
  beforeDestroy() {
    this.stopPolling()
  }
}
</script>

<style scoped>
.payment {
  background-color: #EFF6FF;
  min-height: 80vh;
  padding: 40px 0;
}
.payment .payment-content {
  width: 520px;
  margin: 0 auto;
}
.payment-header span {
  font-size: 20px;
  font-weight: 700;
  color: #059669;
}
.payment-body {
  text-align: center;
  padding: 20px 0;
}
.payment-loading {
  padding: 40px 0;
}
.payment-loading i {
  font-size: 40px;
  color: #059669;
}
.payment-loading p {
  margin: 16px 0;
  color: #666;
}
.order-summary {
  text-align: left;
  background: #FDF3EE;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 24px;
}
.order-summary p {
  margin: 4px 0;
  font-size: 14px;
  color: #064E3B;
}
.qr-section {
  margin: 20px 0;
}
.qr-hint {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}
.qr-img {
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  padding: 8px;
  background: #fff;
}
.wallet-buttons {
  margin: 12px 0;
}
.wallet-hint {
  font-size: 13px;
  color: #888;
  margin-bottom: 12px;
}
.wallet-list {
  display: flex;
  justify-content: center;
  gap: 12px;
}
.wallet-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.wallet-btn:hover {
  opacity: 0.85;
  transform: translateY(-1px);
}
.wallet-icon {
  display: flex;
  align-items: center;
}
.phonepe-btn {
  background: #F5F0FA;
  color: #5F259F;
  border-color: #DCCFEE;
}
.phonepe-btn:hover {
  background: #EDE2F6;
}
.gpay-btn {
  background: #F8F9FA;
  color: #3C4043;
  border-color: #DADCE0;
}
.gpay-btn:hover {
  background: #E8EAED;
}
.qr-status {
  margin-top: 16px;
  color: #059669;
  font-weight: 600;
}
.qr-status i {
  margin-right: 6px;
}
.payment-actions {
  margin-top: 24px;
  display: flex;
  justify-content: center;
  gap: 12px;
}
.not-found {
  height: 500px;
  text-align: center;
  line-height: 500px;
  font-size: 18px;
  color: #888;
}
</style>
